<template>
  <div class="container-page fcs">
    <p class="title-inner">Выгрузка ФТС</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.import"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из Excel' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <div class="mb-4">
      <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
    </div>
    <div v-if="isAccessAllowed">
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Год</th>
              <th>Месяц</th>
              <th>Направление перемещения</th>
              <th>Страна</th>
              <th>Код ТН ВЭД</th>
              <th>Наименование товара</th>
              <th>Стоимость, тыс.$ США</th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput
                  v-model="filter.year"
                  type="year"
                  placeholder="Год"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  :select2Options="months"
                  placeholder="Выберите"
                  type="select2"
                  v-model="filter.month"
                  :select2Settings="select2Settings"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th>
                <FilterInput
                  :select2Options="typeList"
                  :placeholder="Все"
                  type="select2"
                  v-model="filter.type"
                  :select2Settings="select2Settings"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  type="select2"
                  :select2Options="countries"
                  :select2Settings="select2Settings"
                  v-model="filter.countryId"
                  placeholder="(Все)"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput v-model="filter.tnvedCode" v-on:valueChangedDebounced="changeFilter" />
              </th>
              <th class="filter">
                <FilterInput v-model="filter.tnvedName" v-on:valueChangedDebounced="changeFilter" />
              </th>
              <th class="filter">
                <div class="range">
                  <FilterInput
                    type="number"
                    v-model="filter.valueFrom"
                    class="mr-2"
                    placeholder="от"
                    v-on:valueChangedDebounced="changeFilter"
                  />
                  <FilterInput
                    type="number"
                    v-model="filter.valueTo"
                    placeholder="до"
                    v-on:valueChangedDebounced="changeFilter"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ item.year }}</td>
              <td>{{ item.month == 0 ? '' : months[item.month - 1].text }}</td>
              <td>{{ item.isImport ? 'импорт' : 'экспорт' }}</td>
              <td>{{ item.country?.nameFull || item.country?.name }}</td>
              <td>{{ item.nsiTnved?.code }}</td>
              <td>{{ item.nsiTnved?.name }}</td>
              <td>{{ item.value?.toFixed(5) }}</td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="5">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="5">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <section>
      <ModalComponent v-model="importModal" title="Импорт файла" @close="closeModal">
        <div class="fcs__import-actions">
          <input type="text" v-model="csvName" />
          <ButtonComponent mod="gradient-bg" buttonType="button" @click="importCsv">Загрузить csv</ButtonComponent>
          <ButtonComponent mod="gradient-bg" buttonType="button" @click="calculateSummary"
            >Запустить пересчет</ButtonComponent
          >
        </div>
        <ImportModal @doimport="doImport" @close="closeModal" />
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ImportModal from '@/components/modals/ImportModal.vue';

  import FilterInput from '../../../common/components/FilterInput.vue';
  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.ExportProductView,
    import: Constants.Permissions.ExportProductImport,
  };

  export default {
    name: 'ExportProduct',
    components: { FilterInput, ImportModal, ModalComponent, ButtonComponent, DefaultFilter },
    mixins: [security],
    data() {
      return {
        route: 'exportproduct',
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: {
          year: null,
          countryId: null,
          tnvedCode: null,
          tnvedName: null,
          valueFrom: null,
          valueTo: null,
          type: null,
          isImport: null,
        },
        importInProgress: false,
        importModal: false,
        isLoading: false,

        csvName: '',

        select2Settings: Constants.select2Settings,
        typeList: [
          { id: 0, text: 'экспорт' },
          { id: 1, text: 'импорт' },
        ],
        months: Constants.monthList,
      };
    },
    computed: {
      permissions: () => PERMISSIONS,
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;

        loadFilter(this.$options.name).then((response) => {
          let filter = response;
          if (filter) {
            this.filter = filter;
          }
          this.loadDictionaries();
          this.loadPage();
        });
      });
    },
    methods: {
      loadPage(append) {
        this.isLoading = !append;
        const request = Object.assign(this.filter, this.request);
        request.isImport = null;
        if (this.filter.type == 0) request.isImport = false;
        else if (this.filter.type == 1) request.isImport = true;

        Api.search(this.route, request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      loadDictionaries() {
        Utils.searchNsi('countrylistwithdata', {})
          .then((response) => {
            this.countries = response.data.map((x) => {
              return { text: x.name, id: x.id };
            });
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        this.closeModal();
        this.importInProgress = true;
        Api.downloadFile(this.route, file)
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
            this.loadPage();
            this.importInProgress = false;
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Constants.alert.fire('Импорт', 'Ошибка при импорте данных.', 'error');
            this.importInProgress = false;
          });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      closeModal() {
        this.importModal = false;
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
      importCsv() {
        this.closeModal();
        this.importInProgress = true;
        Api.importCsv(this.csvName)
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
            this.loadPage();
            this.importInProgress = false;
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Constants.alert.fire('Импорт', 'Ошибка при импорте данных.', 'error');
            this.importInProgress = false;
          });
      },
      calculateSummary() {
        this.closeModal();
        Api.calculateSummary(this.csvName)
          .then(() => {
            Constants.alert.fire('Процесс пересчета', 'Процесс пересчета успешно выполнен.', 'success');
            this.importInProgress = false;
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Constants.alert.fire('Процесс пересчета', 'Ошибка при запуске.', 'error');
            this.importInProgress = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .fcs {
    &__import-actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
</style>
